import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const DialogBox = ({
  title, text, handleClose, handleAccept, open, acceptButton, closeButton,
}) => (
  <div>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ color: 'black' }}>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {closeButton}
        </Button>
        <Button
          onClick={handleAccept}
          color="primary"
          autoFocus
        >
          {acceptButton}
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

DialogBox.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.any.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  acceptButton: PropTypes.string,
  closeButton: PropTypes.string,
};

DialogBox.defaultProps = {
  acceptButton: 'Ok',
  closeButton: 'Avbryt',
};

export default DialogBox;
